<span
    [ngClass]="{
        'ai-temporary-message': true,
        'ai-temporary-message--success': severity() === 'success',
        'ai-temporary-message--danger': severity() === 'danger',
        'ai-temporary-message--warning': severity() === 'warning',
        'ai-temporary-message--info': severity() === 'info',
        'ai-temporary-message--small': size() === 'small',
        'ai-temporary-message--large': size() === 'large',
        'ai-temporary-message--medium': size() === 'medium',
    }"
    [ngStyle]="{ opacity: opacity(), transition: 'opacity 0.3s ease-in-out' }"
    >{{ message() }}</span
>
